import Vue from 'vue';

import VueScrollTo from 'vue-scrollto';
import VueMeta from 'vue-meta';

import App from './App.vue';
import router from './router';
import store from './store';
// import './registerServiceWorker';

import i18n from './i18n';
import './fontawesome';
import './filters';
import './global-components';

Vue.config.productionTip = false;

Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: 0,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
});

Vue.use(VueMeta);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
